import { Action, createReducer, on } from '@ngrx/store';
import { RowDataDb, SectionData, SectionDataDb, SubSectionData, SubSectionDataDb } from 'src/app/model/help';
import * as HelpActions from './help.actions';
import { Lang } from 'src/app/model/lang';

export interface State {
    helpList: SectionData[];
    helpSearchList: SubSectionData[];
    sections: SectionDataDb[];
    sectionCurrent: SectionDataDb;
    sectionModify: boolean;
    subsectionCurrent: SubSectionDataDb;
    subsections: SubSectionDataDb[];
    subsectionModify: boolean;
    rowCurrent: RowDataDb;
    rows: RowDataDb[];
    rowModify: boolean;
    viewLangHelpAll: Lang;
    helpGuestLoading: boolean;
    helpGuestSearchLoading: boolean;
    helpAllLoading: boolean;
}

export const initialState: State = {
    helpList: [],
    helpSearchList: [],
    sections: [],
    sectionCurrent: undefined,
    sectionModify: false,
    subsectionCurrent: undefined,
    subsections: [],
    subsectionModify: false,
    rowCurrent: undefined,
    rows: [],
    rowModify: false,
    viewLangHelpAll: undefined,
    helpGuestLoading: false,
    helpGuestSearchLoading: false,
    helpAllLoading: false,
};

const helpReducer = createReducer(
    initialState,
    on(HelpActions.getHelp, (state) => ({
        ...state, helpList: []
    })),
    on(HelpActions.getHelpAll, (state) => ({
        ...state, helpList: [], helpAllLoading: true
    })),
    on(HelpActions.getHelpAllLangParam, (state) => ({
        ...state, helpList: [], helpAllLoading: true
    })),
    on(HelpActions.getHelpSearch, (state) => ({
        ...state, helpSearchList: []
    })),
    on(HelpActions.getHelpGuest, (state) => ({
        ...state, helpList: [], helpGuestLoading: true,
    })),
    on(HelpActions.getHelpGuestLangParam, (state) => ({
        ...state, helpList: [], helpGuestLoading: true,
    })),
    on(HelpActions.getHelpGuestSearchLangParam, (state) => ({
        ...state, helpSearchList: [], helpGuestSearchLoading: true,
    })),
    on(HelpActions.getHelpGuestSearch, (state) => ({
        ...state, helpSearchList: [], helpGuestSearchLoading: true,
    })),
    on(HelpActions.getHelpSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList
    })),
    on(HelpActions.getHelpAllSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList, sectionModify: false,
        rowModify: false, subsectionModify: false, helpAllLoading: false
    })),
    on(HelpActions.getHelpAllLangParamSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList, sectionModify: false,
        rowModify: false, subsectionModify: false, viewLangHelpAll: payload.viewLangHelpAll,
        helpAllLoading: false
    })),
    on(HelpActions.getHelpAllFailed, (state) => ({
        ...state, sectionModify: false,
        rowModify: false, subsectionModify: false, helpAllLoading: false
    })),
    on(HelpActions.getHelpGuestSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList, helpGuestLoading: false
    })),
    on(HelpActions.getHelpGuestFailed, (state) => ({
        ...state, helpGuestLoading: false
    })),
    on(HelpActions.getHelpGuestSearchSuccess, (state, payload) => ({
        ...state, helpSearchList: payload.subSectionList, helpGuestSearchLoading: false
    })),
    on(HelpActions.getHelpGuestSearchFailed, (state) => ({
        ...state, helpGuestSearchLoading: false
    })),
    on(HelpActions.getHelpSearchSuccess, (state, payload) => ({
        ...state, helpSearchList: payload.subSectionList
    })),
    on(HelpActions.getHelpSectionAllSuccess, (state, payload) => ({
        ...state,
        sections: payload.sectionList, sectionModify: false
    })),
    on(HelpActions.getHelpSectionSuccess, (state, payload) => ({
        ...state,
        sectionCurrent: payload.section
    })),
    on(HelpActions.getHelpSectionsSuccess, (state, payload) => ({
        ...state,
        sections: payload.sections
    })),
    on(HelpActions.addHelpSectionSuccess, (state) => ({
        ...state, sectionModify: true
    })),
    on(HelpActions.editHelpSectionSuccess, (state) => ({
        ...state, sectionModify: true
    })),
    on(HelpActions.deleteHelpSectionSuccess, (state) => ({
        ...state, sectionModify: true
    })),
    on(HelpActions.resetSectionForm, (state) => ({
        ...state, sectionCurrent: undefined, sectionModify: false,
    })),
    on(HelpActions.getHelpSubSectionsSuccess, (state, payload) => ({
        ...state,
        subsections: payload.subsections
    })),
    on(HelpActions.getHelpSubSectionSuccess, (state, payload) => ({
        ...state,
        subsectionCurrent: payload.subsection
    })),
    on(HelpActions.addHelpSubSectionSuccess, (state) => ({
        ...state, subsectionModify: true
    })),
    on(HelpActions.editHelpSubSectionSuccess, (state) => ({
        ...state, subsectionModify: true
    })),
    on(HelpActions.deleteHelpSubSectionSuccess, (state) => ({
        ...state, subsectionModify: true
    })),
    on(HelpActions.resetSubSectionForm, (state) => ({
        ...state, subsectionCurrent: undefined, subsectionModify: false,
    })),
    on(HelpActions.getHelpRowsSuccess, (state, payload) => ({
        ...state,
        rows: payload.rows
    })),
    on(HelpActions.resetGetHelpRow, (state) => ({
        ...state,
        rowCurrent: undefined
    })),
    on(HelpActions.getHelpRowSuccess, (state, payload) => ({
        ...state,
        rowCurrent: payload.row
    })),
    on(HelpActions.addHelpRowSuccess, (state) => ({
        ...state, rowModify: true
    })),
    on(HelpActions.editHelpRowSuccess, (state) => ({
        ...state, rowModify: true
    })),
    on(HelpActions.deleteHelpRowSuccess, (state) => ({
        ...state, rowModify: true
    })),
    on(HelpActions.resetRowForm, (state) => ({
        ...state, rowCurrent: undefined, rowModify: false,
    })),
);

export const reducer = (state: State | undefined, action: Action): State => helpReducer(state, action);
